import { message } from 'antd';
import { SubCategoryTipCreateData, useSubCategoryTipCreate } from '../../../../../hooks/api/subCategoryTip';
import { DefaultFetchError, FetchSuccess, getMessageInError } from '../../../../../hooks/fetch';

export const useTipCreate = () => {
  const subCategoryTipCreate = useSubCategoryTipCreate();

  const createTip = async (
    data: SubCategoryTipCreateData,
    subCategoryId: string,
  ): Promise<FetchSuccess | void> => await subCategoryTipCreate.fetch(data, `${subCategoryId}/tips`)
    .then((response) => {
      if (response?.success) {
        message.success('Tip saved successfully');
      } else {
        message.error('Failed to save tip');
      }

      return response || undefined;
    })
    .catch((error: DefaultFetchError) => {
      message.error(getMessageInError(error));
    });

  return {
    createTip,
    response: subCategoryTipCreate.response,
    loading: subCategoryTipCreate.loading,
    error: subCategoryTipCreate.error,
  };
};

export default {
  useTipCreate,
};
